module.exports = __webpack_public_path__ + "img/roadmap-bg-3.bac7e678.png";